import { getServiceItemPrice, getIntegerAsString, getDateAsMoment, getItemSubcontractor } from 'data/booking/selectors/form';

function getDefaultValues() {
    return {
        startDate: null,
        endDate: null,
        place: {
            type: 'stop',
            stop: {
                title: 'Le Puy en Velay',
                address: 'Rue des Aubépins, 43370 Cussac-sur-Loire',
                latitude: '44.991536',
                longitude: '3.8675263'
            },
            title: 'Le Puy en Velay'
        },
        vehicleCount: 0,
        price: null,
        comment: null
    };
}

function getDefaultStepId() {
    return "step-1b3a77b8-d891-43e9-8b18-d0a4ed609893";
}

function getEditValues(state) {
    const { entities, editingItem } = state.booking;
    const item = entities.items[editingItem];

    return {
        startDate: getDateAsMoment(item.startDate),
        endDate: getDateAsMoment(item.endDate),
        place: item.place,
        vehicleCount: item.vehicleCount,
        price: getServiceItemPrice(item.price),
        comment: item.comment
    };
}

function equals(itemA, itemB){
    return getDateAsMoment(itemA.startDate).format() == getDateAsMoment(itemB.startDate).format()
        && getDateAsMoment(itemA.endDate).format() == getDateAsMoment(itemB.endDate).format()
        && itemA.vehicleCount == itemB.vehicleCount
        && itemA.place && itemB.place && itemA.place.id == itemB.place.id
}

export {
    getDefaultValues,
    getEditValues,
    getDefaultStepId,
    equals
};
